import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class BaseService {
  public urlApi: string = `${environment.api.url}:${environment.api.port}/v1`;
  public urlApiPresencial: string = `${environment.signalr.url}:${environment.signalr.port}/api`;
  public authenticationKey: string = 'token';

  constructor(protected http: HttpClient) {}

  public get currentUser(): any {
    let user = localStorage.getItem('user');
    return user;
  }
}
